import { render, staticRenderFns } from "./createProfilePage.vue?vue&type=template&id=5f489f44&scoped=true"
import script from "./createProfilePage.vue?vue&type=script&lang=js"
export * from "./createProfilePage.vue?vue&type=script&lang=js"
import style0 from "./createProfilePage.vue?vue&type=style&index=0&id=5f489f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f489f44",
  null
  
)

export default component.exports